import React, { FC } from 'react'

import { Text, TextName } from 'sdk/text/Text'
import { Pill } from 'sdk/pill/Pill'

import classes from './style.module.scss'

interface ComponentProps {
  category: 'news' | 'events'
  date: string
  title: string
  url: string
  image: string
  isBold?: boolean
}

export const NewsCard: FC<ComponentProps> = ({
  category,
  date,
  title,
  url,
  image,
  isBold = false,
}) => {
  const categoryPillBackground = category === 'news' ? 'accent-2' : 'accent-1'

  return (
    <a 
      href={url}
      className={classes.container}
      style={{ '--bg-image': `url(${image})` } as React.CSSProperties}
    >
      <div className={classes.content}>
        <div className={classes.pillsRow}>
          <Pill 
            text={category === 'news' ? 'News' : 'Events'}
            variant="filled"
            background={categoryPillBackground}
            size="sm"
          />
          <Pill 
            text={date}
            variant="outline"
            size="sm"
          />
        </div>
        
        <div className={classes.titleRow}>
          <Text type={isBold ? TextName.TextBold : TextName.Text} className={classes.title}>
            {title}
          </Text>
        </div>
      </div>
    </a>
  )
}